// All options / translations/ values that available for the query users

import {Cached} from '@utils';
import {UsersQuerySortBy} from './users-query.builder';
import {FilterOptions} from '@shared-types';
import {SortDirection} from '@angular/material/sort';

export type IQueryUsersData = {
	Sorting: {
		markers: Record<(typeof UsersQuerySortBy)[keyof typeof UsersQuerySortBy], FilterOptions<UsersQuerySortBy>>;
		directions: Record<SortDirection, FilterOptions<SortDirection>>;
	};
	// UserTypes: Record<UserType, FilterOptions<boolean>>;
	Filters: {
		includeDisabled: FilterOptions<boolean>;
		includePermanent: FilterOptions<boolean>;
		includeTemporary: FilterOptions<boolean>;
	};
};

export class QueryUsersData {
	@Cached()
	static getQueryUsersData(): IQueryUsersData {
		return {
			Sorting: {
				markers: {
					[UsersQuerySortBy.username]: {
						label: 'pages.users.username',
						icon: 'fa-duotone fa-user',
						isDefaultFilter: true,
						value: UsersQuerySortBy.username,
					},
					[UsersQuerySortBy.name]: {
						label: 'pages.users.name',
						icon: 'fa-duotone fa-signature',
						value: UsersQuerySortBy.name,
					},
					[UsersQuerySortBy.email]: {
						label: 'pages.users.email',
						icon: 'fa-duotone fa-at',
						value: UsersQuerySortBy.email,
					},
					[UsersQuerySortBy.phonenumber]: {
						label: 'pages.users.phone',
						icon: 'fa-duotone fa-phone',
						value: UsersQuerySortBy.phonenumber,
					},
					[UsersQuerySortBy.enabled]: {
						label: 'pages.users.statuses.active',
						icon: 'fa-duotone fa-toggle-on',
						value: UsersQuerySortBy.enabled,
					},
				},
				directions: {
					['asc']: {
						label: 'dccomp.dc-table.sort.asc',
						icon: 'fa-solid fa-arrow-up',
						value: 'asc',
					},
					['desc']: {
						label: 'dccomp.dc-table.sort.desc',
						icon: 'fa-solid fa-arrow-down',
						value: 'desc',
					},
					['']: {
						label: 'dccomp.dc-table.sort.none',
						icon: 'fa-solid fa-sort',
						value: '',
					},
				},
			},
			// UserTypes: {
			// 	[UserType.Registered]: {
			// 		label: 'pages.users.statuses.active',
			// 		icon: 'fa-duotone fa-user',
			// 	},
			// 	[UserType.Email]: {
			// 		label: 'pages.users.communication.emailSrc',
			// 		icon: 'fa-duotone fa-at',
			// 	},
			// 	[UserType.Sms]: {
			// 		label: 'pages.users.communication.smsSrc',
			// 		icon: 'fa-duotone fa-comment-sms',
			// 	},
			// 	[UserType.Whatsapp]: {
			// 		label: 'pages.users.communication.whatsappSrc',
			// 		icon: 'fa-brands fa-whatsapp',
			// 	},
			// 	[UserType.Qr]: {
			// 		label: 'struct.toolbox.qr',
			// 		icon: 'fa-duotone fa-qrcode',
			// 	},
			// },
			Filters: {
				includeDisabled: {
					label: 'pages.users.actions.showdeleted',
					icon: 'fa-duotone fa-user-slash',
					value: false,
				},
				includePermanent: {
					label: 'dccomp.address-book.showSystemUsersBtn',
					icon: 'fa-duotone fa-user-check',
					value: true,
					isDefaultFilter: true,
				},
				includeTemporary: {
					label: 'struct.user-edit.showTempUsers',
					icon: 'fa-duotone fa-user-clock',
					value: false,
				},
			},
		};
	}
}
